import PeriodSalesPage from './PeriodSalesPage';

export default PeriodSalesPage;
